import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItemCard, LineItemModels, GlassesPrescription, PrescriptionTable } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';

const LineItemsContainer = ({ lineItems  })=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            quantity: intl.getLabel('cart.item.quantity'),
            iconLeftEye: intl.getLabel('products.contactLenses.leftEye'),
            iconRightEye: intl.getLabel('products.contactLenses.rightEye'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            monthlySubscription: intl.getLabel('products.monthlySubscription'),
            deliveredEvery: intl.getLabel('cart.delivery.frequency'),
            perBox: intl.getLabel('products.perBox'),
            configuration: intl.getLabel('account.order.detail.configuration'),
            prescription: intl.getLabel('account.order.detail.prescription')
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem, i)=>{
        const baseProps = {
            currency: intl.currency,
            discountPrice: lineItem.discountPrice ? lineItem.price : 0,
            imagePath: lineItem.imageUrl,
            labels: {
                configuration: labels.configuration,
                prescription: labels.prescription
            },
            lineItemId: lineItem.lineItemId,
            price: lineItem.price,
            quantity: lineItem.quantity,
            subtitle: lineItem.subtitle,
            title: lineItem.title,
            compactCard: true
        };
        if ('bundleChildLineItems' in lineItem) {
            baseProps.bundleChildLineItems = lineItem.bundleChildLineItems;
        }
        return /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${lineItem.lineItemId}+${i}`
        }, baseProps), 'prescription' in lineItem ? /*#__PURE__*/ React.createElement(LineItemCard.PrescriptionSection, {
            labels: baseProps.labels
        }, LineItemModels.isGlassesBundleLineItem(lineItem) ? /*#__PURE__*/ React.createElement(GlassesPrescription, {
            intl: intl,
            prescription: lineItem.prescription
        }) : /*#__PURE__*/ React.createElement(PrescriptionTable, {
            size: "narrow",
            orientation: "eyeSideTop",
            prescription: swcHelpers.objectSpread({}, lineItem.prescription)
        })) : null);
    }));
};

export { LineItemsContainer };
//# sourceMappingURL=LineItemContainer.js.map
